import { render, staticRenderFns } from "./TeamManagement.vue?vue&type=template&id=332fbc4e&scoped=true"
import script from "./TeamManagement.vue?vue&type=script&lang=js"
export * from "./TeamManagement.vue?vue&type=script&lang=js"
import style0 from "./TeamManagement.vue?vue&type=style&index=0&id=332fbc4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332fbc4e",
  null
  
)

export default component.exports